
import {DocumentCardinality, DocumentScope, DocumentType } from "../../../../src/api/caseDocuments";

export interface DocumentConfigItem {
  scope: DocumentScope;
  cardinality: DocumentCardinality;
  order: number;
  requiresNote?: boolean;
  displayName: string;
  dropdownLabel?: string; 
}

export const DOCUMENT_CONFIG: Record<DocumentType, DocumentConfigItem> = {
  [DocumentType.CASE_BACKGROUND]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 1,
    displayName: "Case Background",
    dropdownLabel: "Case Background",
  },

  [DocumentType.INVESTIGATION_REPORT]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.SINGLETON,
    order: 2,
    displayName: "IR",
    dropdownLabel: "Investigation Report",
  },

  [DocumentType.SCN]: {
    scope: DocumentScope.PARTY,
    cardinality: DocumentCardinality.SINGLETON,
    order: 3,
    displayName: "Show Cause Notice",
    dropdownLabel: "Show Cause Notice",
  },

  [DocumentType.SCN_RESPONSE]: {
    scope: DocumentScope.PARTY,
    cardinality: DocumentCardinality.SINGLETON,
    order: 4,
    displayName: "SCN Response",
    dropdownLabel: "SCN Response",
  },

  [DocumentType.COMMITTEE_REPORT]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 5,
    displayName: "Committee Report",
    dropdownLabel: "Committee Report",
  },

  [DocumentType.REASONED_ORDER]: {
    scope: DocumentScope.PARTY,
    cardinality: DocumentCardinality.SINGLETON,
    order: 6,
    displayName: "Reasoned Order",
    dropdownLabel: "Reasoned Order",
  },

  [DocumentType.FMR1]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 7,
    displayName: "FMR 1",
    dropdownLabel: "FMR 1",
  },

  [DocumentType.LEA_REPORT]: {
    scope: DocumentScope.LEA,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 8,
    displayName: "LEA Report",
    dropdownLabel: "LEA Report",
  },

  [DocumentType.SAE_REPORT]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 9,
    displayName: "SAE Report",
    dropdownLabel: "SAE Report",
  },

  [DocumentType.RECOVERY_SARFAESI]: {
    scope: DocumentScope.LOAN_ACCOUNT,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 10,
    displayName: "Recovery SARFAESI",
    dropdownLabel: "Recovery – SARFAESI",
  },

  [DocumentType.RECOVERY_DRT]: {
    scope: DocumentScope.LOAN_ACCOUNT,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 11,
    displayName: "Recovery DRT",
    dropdownLabel: "Recovery – DRT",
  },

  [DocumentType.RECOVERY_NCLT]: {
    scope: DocumentScope.LOAN_ACCOUNT,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 12,
    displayName: "Recovery NCLT",
    dropdownLabel: "Recovery – NCLT",
  },

  [DocumentType.RECOVERY_COURT_CASE]: {
    scope: DocumentScope.LOAN_ACCOUNT,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 13,
    displayName: "Recovery Court Case",
    dropdownLabel: "Recovery – Court Case",
  },

  [DocumentType.OTHERS]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    requiresNote: true,
    order: 14,
    displayName: "Others",
    dropdownLabel: "Others",
  },

  [DocumentType.IO_APPOINTING_AUTH_REVIEW]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 15,
    displayName: "IO App. Auth Review",
    dropdownLabel: "IO App. Auth Review",
  },

  [DocumentType.INVESTIGATION_SUPPORTING]: {
    scope: DocumentScope.CASE,
    cardinality: DocumentCardinality.MULTIPLE,
    order: 16,
    displayName: "Supporting Documents",
    dropdownLabel: "Supporting Documents",
  },
};
